<template>
  <v-card class="align-stretch" height="100%" :loading="currentLeadLoading">
    <v-card-title>
      Lead Source
      <v-spacer></v-spacer>
      <v-btn class="mt-0" color="secondary" x-small @click="dialogOpen = true"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>
    <v-card-text v-if="!currentLeadLoading">
      <v-row>
        <v-col>
          <div class="d-flex align-center">
            <p class="mb-1 mr-1 text-caption">Source</p>
            <BaseInfoTooltip top>
              The marketing channel that the lead came from
            </BaseInfoTooltip>
          </div>
          
          <p><b>{{currentLead.source | notEmpty}}</b></p>

          <div class="d-flex align-center">
            <p class="mb-1 mr-1 text-caption">Channel</p>
            <BaseInfoTooltip top>
              Whether the sale is inbound or outbound
            </BaseInfoTooltip>
          </div>
          
          <p><b>{{currentLead.channel | notEmpty}}</b></p>

          <div class="d-flex align-center">
            <p class="mb-1 mr-1 text-caption">Referrer</p>
            <BaseInfoTooltip top>
              The person who refers this lead to us
            </BaseInfoTooltip>
          </div>

          <p><b>{{currentLead.referrer | notEmpty}}</b></p>
        </v-col>
      </v-row>
    </v-card-text>
    <LeadSourceDialog :dialogOpen="dialogOpen" @close-dialog="dialogOpen=false;" />
  </v-card>
</template>

<script>
  import { mapActions, mapState } from "vuex";
  import LeadSourceDialog from './Dialogs/LeadSourceDialog';
  export default {
    components: { LeadSourceDialog },

    computed: {
      ...mapState('leads', ['currentLead','currentLeadLoading']),
    },

    methods: {
      ...mapActions('alerts', ['setAlert']),
    },

    data() {
      return {
        dialogOpen: false
      }
    },
    
    filters: {
      notEmpty: (val)=>{
        return (val === null || val === "" || val === undefined)?'-':val;
      },
    }
  }
</script>

<style lang="scss" scoped></style>
